<template>
  <smd-one-col-layout class="doctor-search">
    <div class="flex-row-center-xy-spaced">
      <smd-btn section="4"
               variant="blue-enabled"
               @click="doctorSearch">
        <text-string label-id="txt012"/>
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  export default {
    name: 'doctor-search',
    methods: {
      doctorSearch() {
        window.open('https://nowserving.ph/', '_blank');
      },
    },
  }
</script>
